import _moment from "moment";
import i18n from '@/i18n.js';



const getCurrentDate = () => {
    return new Date();
}

const getCurrentSeconds = () => {
    return Number.parseInt(getCurrentTimeStamp() / 1000);
}

const getCurrentTimeStamp = () => {
    return new Date().getTime();
}

const getGmtTimeStamp = (time_zone) => {

    let date = new Date();
    let offset_GMT = date.getTimezoneOffset();
    let nowDate = date.getTime();

    return nowDate + offset_GMT * 60 * 1000 + time_zone * 60 * 60 * 1000;
}

const getGmt8TimeStamp = () => {
    let time_zone = 8;
    return getGmtTimeStamp(time_zone);
}

// const getBeijingTime = (currentDate) => {

//     let d = new Date();
//     let time_zone = -d.getTimezoneOffset() / 60;
//     currentDate.setHours(currentDate.getHours() + time_zone);
//     return currentDate;
// }

const secondsFormatRow = (row, column, cellValue) => {
    var data = row[column.property];
    if (data == undefined || data == "0") {
        return "0";
    }
    return secondsFormat(data);
}

const secondsFormat = (data) => {
    if (data == undefined || data == null || data == "0") {
        return "0";
    }
    var theTime = parseInt(data);
    var theTime1 = 0;
    var theTime2 = 0;
    var theTime3 = 0;
    if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60);
            theTime1 = parseInt(theTime1 % 60);
            if (theTime2 > 24) {

                theTime3 = parseInt(theTime2 / 24);
                theTime2 = parseInt(theTime2 % 24);
            }
        }
    }
    var result = "";
    if (theTime > 0) {
        result = "" + parseInt(theTime) + i18n.t("TimeFormat.Ft1", ["秒"]);
    }
    if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + i18n.t("TimeFormat.Ft2", ["分"]) + result;
    }
    if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + i18n.t("TimeFormat.Ft3", ["小时"]) + result;
    }
    if (theTime3 > 0) {
        result = "" + parseInt(theTime3) + i18n.t("TimeFormat.Ft4", ["天"]) + result;
    }
    return result;
}

const endSecondsFormat = (data) => {
    if (data == undefined || data == null || data == "0") {
        return "0";
    }
    var timeseconds = (data - new Date().getTime()) / 1000
    if (timeseconds < 0) {
        return dateFormatByDateAndPattern(
            data,
            'YYYY-MM-DD'
        )
    }
    var theTime = parseInt(timeseconds);
    var theTime1 = 0;
    var theTime2 = 0;
    var theTime3 = 0;
    if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60);
            theTime1 = parseInt(theTime1 % 60);
            if (theTime2 > 24) {

                theTime3 = parseInt(theTime2 / 24);
                theTime2 = parseInt(theTime2 % 24);
            }
        }
    }
    var result = "";
    if (theTime > 0) {
        result = "" + parseInt(theTime) + i18n.t("TimeFormat.Ft1", ["秒"]);
    }
    if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + i18n.t("TimeFormat.Ft2", ["分"]) + " " + result;
    }
    if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + i18n.t("TimeFormat.Ft3", ["小时"]) + " " + result;
    }
    if (theTime3 > 0) {
        result = "" + parseInt(theTime3) + i18n.t("TimeFormat.Ft4", ["天"]) + " " + result;
    }
    return result;
}

const secondsFormatV2 = (data) => {
    if (data == undefined || data == null || data == "0") {
        return "0";
    }
    var theTime = parseInt(data);
    var theTime1 = 0;
    var theTime2 = 0;
    var theTime3 = 0;
    if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60);
            theTime1 = parseInt(theTime1 % 60);
            if (theTime2 > 24) {

                theTime3 = parseInt(theTime2 / 24);
                theTime2 = parseInt(theTime2 % 24);
            }
        }
    }
    var result = "";
    if (theTime > 0) {
        result = "" + parseInt(theTime) + "";
    }
    if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + ":" + result;
    }
    if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + ":" + result;
    }
    if (theTime3 > 0) {
        result = "" + parseInt(theTime3) + " " + result;
    }
    return result;
}
const dateTimeFormatRow = (row, column, cellValue) => {
    if (!cellValue) {
        return ''
    }
    return dateFormatByDate(cellValue);
}

const dateFormatRow = (row, column, cellValue) => {
    if (!cellValue) {
        return ''
    }
    return dateFormatByDateAndPattern(cellValue, "YYYY-MM-DD");
}

const dateFormatByDate = (date) => {
    if (!date) {
        return ''
    }

    return dateFormatByDateAndPattern(date, "YYYY-MM-DD HH:mm:ss");
}

const dateFormatByDateAndPattern = (date, pattern) => {
    if (!date) {
        return ''
    }
    return _moment(date).format(pattern)
}

const dateSecondsFormatRow = (row, column, cellValue) => {
    if (!cellValue) {
        return ''
    }
    return dateFormatByDate(cellValue * 1000);
}

const dateSeconds2DateFormatRow = (row, column, cellValue) => {
    if (!cellValue) {
        return ''
    }
    return dateSecondsFormatByDateAndPattern(cellValue, "YYYY-MM-DD");
}

const dateSecondsFormatByDate = (timeStamp) => {
    if (!timeStamp) {
        return ''
    }

    return dateSecondsFormatByDateAndPattern(timeStamp, "YYYY-MM-DD HH:mm:ss");
}

const dateSecondsFormatByDateAndPattern = (timeStamp, pattern) => {
    if (!timeStamp) {
        return ''
    }
    return _moment(timeStamp * 1000).format(pattern)
}


const addMilliseconds = (date, value) => {
    date = new Date(date.getTime());
    date.setMilliseconds(date.getMilliseconds() + value);
    return date;
}


const addSeconds = (date, value) => {
    date = new Date(date.getTime());
    date.setSeconds(date.getSeconds() + value);
    return date;
}


const addMinutes = (date, value) => {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + value);
    return date;
}

const addHours = (date, value) => {
    date = new Date(date.getTime());
    date.setHours(date.getHours() + value);
    return date;
}

const addDays = (date, value) => {
    date = new Date(date.getTime());
    date.setDate(date.getDate() + value);
    return date;
}

const addMonths = (date, value) => {
    date = new Date(date.getTime());
    date.setMonth(date.getMonth() + value);
    return date;
}

const addYears = (date, value) => {
    date = new Date(date.getTime());
    date.setFullYear(date.getFullYear() + value);
    return date;
}

const comparedTo = (from, to) => {
        let fromTime = from.getMilliseconds();
        let toTime = to.getMilliseconds();
        return (fromTime < toTime ? -1 : (fromTime == toTime ? 0 : 1));
    }

const TimegetBenifit1 = (date) => {
        var timestamp = Date.parse(new Date())
        var daystime = timestamp - date
        var days = parseInt(daystime / (1000 * 60 * 60 * 24));
        if (days < 181) {
            return days
        } else {
            return 181
        }
    }

const TimegetBenifit2 = (date) => {
    var timestamp = Date.parse(new Date())
    var daystime = timestamp - date
    var days = parseInt(daystime / (1000 * 60 * 60 * 24));
    if (days < 181) {
        return 181 - days
    } else {
        return 0
    }
}
const TimegetBenifit3 = (date, dd) => {
    var timestamp = Date.parse(new Date())
    var daystime = timestamp - date
    var days = parseInt(daystime / (1000 * 60 * 60 * 24));
    if (days < dd) {
        return dd - days
    } else {
        return 0
    }
}
const TimegetBenifit4 = (date, dd) => {
    var timestamp = Date.parse(new Date())
    var daystime = timestamp - date
    var days = parseInt(daystime / (1000 * 60 * 60 * 24));
    if (days < dd) {
        return days
    } else {
        return dd
    }
}
export default {
    getCurrentDate,
    getCurrentSeconds,
    getCurrentTimeStamp,
    // getBeijingTime,
    getGmt8TimeStamp,

    secondsFormatRow,
    secondsFormat, // '61 ->
    secondsFormatV2,
    endSecondsFormat,

    dateTimeFormatRow, // 1605064271000 -> 2020/11/11 11:11:11
    dateFormatRow, // 1605064271000 -> 2020/11/11
    dateFormatByDate,
    dateFormatByDateAndPattern,

    dateSecondsFormatRow, // 1605064271 -> 2020/11/11 11:11:11
    dateSeconds2DateFormatRow, // 1605064271 -> 2020/11/11
    dateSecondsFormatByDate,
    dateSecondsFormatByDateAndPattern,

    addMilliseconds,
    addSeconds,
    addMinutes,
    addHours,
    addDays,
    addMonths,
    addYears,
    comparedTo,

    TimegetBenifit1,
    TimegetBenifit2,
    TimegetBenifit3,
    TimegetBenifit4
};



// WEBPACK FOOTER //
// ./src/models/dateUtils.js